import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';

//import { instanceType, AllTypes } from 'src/tools/helper';
const switchUuidHooks = ({ uuid }) => {
  const _h = useHistory();
  const _params: any = useParams();
  const {
    customerDatabaseUuid,
    tagUuid, //==new
  } = _params;

  useAfterDidMountEffect(() => {
    if (uuid !== tagUuid && uuid) {
      _h.push({
        pathname: `/customerDatabase/tagEdit/${customerDatabaseUuid}/${uuid}`,
        state: {
          skipNotice: true,
        },
      });
      // console.log('uuid switch');
      //   eForceUpdate(uuid);
    }
  }, [uuid]);
};
export { switchUuidHooks };
